import React, {useContext, useEffect, useState} from 'react';
import {GlobalContext} from '../../utilities/GlobalContext';
import {Route, Redirect} from 'react-router-dom';
import hasAccess from './hasAccess';

function PaypalRouter({children, ...rest}) {
	//This router requires the user to be loggedin and bought the content
	let user = useContext(GlobalContext).user;
	let setUser = useContext(GlobalContext).setUser;
	let serverOrigin = useContext(GlobalContext).serverOrigin;
	let loadingUser = useContext(GlobalContext).userLoading;

	let {courseName} = rest;

	let [hasBoughtContent, setHasBoughtContent] = useState(false);
	let [loading, setLoading] = useState(true);

	let hasExited = false;

	useEffect(() => {
		if (loadingUser) {
			return;
		}
		hasAccess(serverOrigin, {
			user: user,
			course: courseName,
		})
			.then(results => {
				if (results.status === 'sucessfull') {
					safylyUpdateState(setHasBoughtContent, true, hasExited);
				}

				safylyUpdateState(setLoading, false, hasExited);
			})
			.catch(err => {
				if (!hasExited) {
					safylyUpdateState(setLoading, false, hasExited);
				}
				console.error(err);
			});
	}, [loadingUser]);

	useEffect(() => {
		hasExited = false;
		return () => {
			hasExited = true;
		};
	}, []);

	return (
		<Route
			{...rest}
			render={() => {
				/* return children; */ /* This is for testing only mark look here find this spot remove bug router change router fix router fix me router find router find here here here01 here02 fix here*/
				if (loadingUser) {
					return <div>Loading</div>;
				}
				if (!user) {
					window.location.href = '/signup';
					return <div>Redirecting</div>;
				} else if (loading) {
					return <div>Loading results</div>;
				} else {
					return hasBoughtContent ? children : <Redirect to={`/${courseName}/purchase`} />;
				}
			}}
		/>
	);

	function safylyUpdateState(seter, value, hasExited) {
		if (!hasExited) {
			seter(value);
		}
	}
}

export default PaypalRouter;
